import { Autocomplete, TextField } from "@mui/material";
import { useEffect, useState } from "react";
import styled from "styled-components";

const MainWrap = styled.div`
    box-sizing: border-box;
    height: 100%;
    // min-height: 100%;
    display: flex;
    flex-direction: column;
    gap: 1rem;
    overflow: hidden;
    .descItem  {
        padding-top: 1rem;
        flex-grow: 1;
        width: 100%;
        display: flex;
        flex-direction: column;
        gap: 1rem;
        overflow: auto;
    }
`;

const SurveyCars = ({survey, codeList}) => {

    const [ccnmList, setCcnmList] = useState(codeList);

    // useEffect(()=>{
    //     if(codeList){
    //         setCcnmList(codeList.cars_class.map((item,index)=>({
    //         ...item,
    //         label:item.ccnm})
    //         ));
    //     }
    // },[codeList])

    return (
        <MainWrap>
            <Autocomplete
                        id="ccid"
                        size='small'
                        options={ccnmList}
                        style={{width:'10rem'}}
                        value={(survey && survey.ccnm) && survey.ccnm}
                        renderInput={(params) => <TextField {...params} label='차량' InputLabelProps={{shrink:true}}/>}
                        // onChange={(e,v)=>(v!==null)&&handleAutoValueChange('ccid',v.ccid,'ccnm',v.ccnm)}
                    />
        </MainWrap>
    )

}

export default SurveyCars;